import React, { useState } from 'react';
import axios from 'axios';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/bootstrap.css';
import { Xmark, SendDiagonal, Star } from 'iconoir-react';
import Lottie from 'lottie-react';
import avaliacaoAnimation from '../assets/avialiacao-restaurante.json';
import './AvaliarLojaModal.css';

const XERXES = 'https://xerxes.grub.digital';

const categorias = [
  { key: 'nota_comida', label: 'Comida', desc: 'Sabor, qualidade e apresentação' },
  { key: 'nota_atendimento', label: 'Atendimento', desc: 'Simpatia e eficiência' },
  { key: 'nota_ambiente', label: 'Ambiente', desc: 'Limpeza e conforto' },
  { key: 'nota_tempo_espera', label: 'Tempo de Espera', desc: 'Rapidez no atendimento' },
  { key: 'nota_custo_beneficio', label: 'Custo-Benefício', desc: 'Preço e experiência' },
];

const AvaliarLojaModal = ({ show, onHide, brand }) => {
  const [notas, setNotas] = useState({
    nota_comida: 0, nota_atendimento: 0, nota_ambiente: 0,
    nota_tempo_espera: 0, nota_custo_beneficio: 0
  });
  const [nome, setNome] = useState('');
  const [telefone, setTelefone] = useState('');
  const [comentario, setComentario] = useState('');
  const [enviado, setEnviado] = useState(false);
  const [erro, setErro] = useState('');
  const [loading, setLoading] = useState(false);

  if (!show) return null;

  const setNota = (key, valor) => setNotas(prev => ({ ...prev, [key]: valor }));

  const validarNome = (valor) => {
    const trimmed = valor.trim();
    if (trimmed.length < 3) return 'Nome muito curto.';
    const palavras = trimmed.split(/\s+/).filter(p => p.length > 0);
    if (palavras.length < 2) return 'Informe nome e sobrenome.';
    if (/\d/.test(trimmed)) return 'Nome não pode conter números.';
    if (!/^[a-zA-ZÀ-ÿ\s'-]+$/.test(trimmed)) return 'Nome contém caracteres inválidos.';
    if (palavras.some(p => p.length < 2)) return 'Por favor, informe um nome válido.';
    return null;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setErro('');

    if (!nome.trim() || !telefone.trim()) {
      setErro('Preencha nome e telefone.');
      return;
    }
    const erroNome = validarNome(nome);
    if (erroNome) { setErro(erroNome); return; }
    if (Object.values(notas).some(n => n === 0)) {
      setErro('Avalie todas as categorias.');
      return;
    }

    setLoading(true);
    try {
      await axios.post(`${XERXES}/v1/site/${brand}/feedback`, {
        id_comanda: null,
        nome: nome.trim(),
        telefone: telefone.trim(),
        comentario: comentario.trim() || null,
        ...notas
      });
      setEnviado(true);
    } catch (err) {
      if (err.response?.status === 409) {
        setErro('Já recebemos uma avaliação recente deste número.');
      } else {
        setErro('Erro ao enviar avaliação. Tente novamente.');
      }
    }
    setLoading(false);
  };

  const handleClose = () => {
    setNome('');
    setTelefone('');
    setComentario('');
    setNotas({ nota_comida: 0, nota_atendimento: 0, nota_ambiente: 0, nota_tempo_espera: 0, nota_custo_beneficio: 0 });
    setErro('');
    setEnviado(false);
    onHide();
  };

  const podaEnviar = nome.trim() && telefone.trim() && !Object.values(notas).some(n => n === 0);

  return (
    <div className="avaliar-overlay" onClick={handleClose}>
      <div className="avaliar-panel" onClick={e => e.stopPropagation()}>

        {/* Header */}
        <div className="avaliar-header">
          <div className="avaliar-header-title">
            <Star width={18} height={18} />
            <span>Avaliar Loja</span>
          </div>
          <button className="avaliar-close" onClick={handleClose}>
            <Xmark width={20} height={20} />
          </button>
        </div>

        {/* Sucesso */}
        {enviado ? (
          <div className="avaliar-sucesso">
            <Lottie animationData={avaliacaoAnimation} loop style={{ width: 160, height: 160 }} />
            <h3>Obrigado pelo feedback!</h3>
            <p>Sua opinião é muito importante para nós.</p>
            <button className="avaliar-btn-primary" onClick={handleClose}>
              Fechar
            </button>
          </div>
        ) : (
          <div className="avaliar-body">
            {erro && <div className="avaliar-erro">{erro}</div>}

            <form onSubmit={handleSubmit}>
              {/* Nome */}
              <div className="avaliar-field">
                <label>Seu nome</label>
                <input
                  type="text"
                  placeholder="Nome completo"
                  value={nome}
                  onChange={e => setNome(e.target.value)}
                  required
                />
              </div>

              {/* Telefone */}
              <div className="avaliar-field">
                <label>Seu telefone</label>
                <PhoneInput
                  country="br"
                  onlyCountries={['br']}
                  value={telefone}
                  onChange={value => setTelefone(value)}
                  inputClass="phone-input-field"
                  buttonClass="phone-input-btn"
                  disableDropdown
                  masks={{ br: '(..) .....-....' }}
                />
              </div>

              {/* Notas por categoria */}
              <div className="avaliar-categorias">
                {categorias.map(cat => (
                  <div key={cat.key} className="avaliar-categoria">
                    <div className="avaliar-categoria-info">
                      <span className="avaliar-categoria-label">{cat.label}</span>
                      <span className="avaliar-categoria-desc">{cat.desc}</span>
                    </div>
                    <div className="avaliar-notas">
                      {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10].map(n => (
                        <button
                          key={n}
                          type="button"
                          onClick={() => setNota(cat.key, n)}
                          className={`avaliar-nota-btn ${notas[cat.key] === n ? 'selected' : ''} ${notas[cat.key] === n ? (n >= 8 ? 'verde' : n >= 5 ? 'amarelo' : 'vermelho') : ''}`}
                        >
                          {n}
                        </button>
                      ))}
                    </div>
                  </div>
                ))}
              </div>

              {/* Comentário */}
              <div className="avaliar-field">
                <label>Comentário (opcional)</label>
                <textarea
                  rows="3"
                  placeholder="Deixe um comentário..."
                  value={comentario}
                  onChange={e => setComentario(e.target.value)}
                />
              </div>

              <button
                type="submit"
                className={`avaliar-btn-primary ${!podaEnviar ? 'disabled' : ''}`}
                disabled={loading || !podaEnviar}
              >
                {loading ? (
                  <><span className="avaliar-spinner" />Enviando...</>
                ) : (
                  <><SendDiagonal width={16} height={16} />Enviar Avaliação</>
                )}
              </button>
            </form>
          </div>
        )}
      </div>
    </div>
  );
};

export default AvaliarLojaModal;
